import { Button } from 'antd';
import { useLocation, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { openNotification } from '../../utils';

const EmailVerifySend = () => {
    const location = useLocation();
    const [loading, setLoading] = useState<boolean>(false);
    const [email, setEmail] = useState<string>('');
    const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const emailParam = queryParams.get('email');
        if (emailParam) {
            setEmail(emailParam);
        }
    }, [location.search]);

    const handleSendVerificationEmail = () => {

        setLoading(true);
        if (isButtonDisabled) return;

        const userData = { email };

        const apiUrl = process.env.REACT_APP_API_BASE_URL + '/auth/verification-send';

        axios.post(apiUrl, userData)
            .then(() => {
                openNotification('success', 'Başarılı', 'Onay e-postası gönderildi. Lütfen e-posta kutunuzu kontrol edin.');
                setIsButtonDisabled(true);
                setLoading(false);
                setTimeout(() => {
                    setIsButtonDisabled(false);
                }, 60000); // 1 dakika sonra butonu aktif et
            })
            .catch((e) => {
                console.log(e);
                openNotification('error', 'Başarısız', 'Bir hata oluştu. Kontrol ederek tekrar deneyin.');
                setLoading(false);
            });
    };

    return (
        <section>
            <h2 className="auth-card-title">Kaydınız tamamlandı</h2>
            <p className="auth-card-description">
                E-posta adresinizi doğrulamak için gelen kutunuzu ve spam klasörünü kontrol edin.
            </p>
            <p className="auth-card-description" style={{ marginTop: 12 }}>
                E-posta ulaşmadıysa onay e-postasını yeniden gönderebilirsiniz.
            </p>
            <div className="auth-card-form">
                <Button
                    onClick={handleSendVerificationEmail}
                    type="primary"
                    size="large"
                    block
                    disabled={isButtonDisabled}
                    loading={loading}
                >
                    Onay E-postasını Yeniden Gönder
                </Button>
            </div>
            <p className="auth-card-footer">
                Hesabınız var mı? <Link to="/giris">Giriş Yap</Link>
            </p>
        </section>
    );
};

export default EmailVerifySend;
